export default function (caseNumber) {
  return {
    name: "Upload Recruitment Report",
    pageInfo: {
      text: "Please upload the Recruitment Report below. Your response will be added to the case documents and directed to an analyst for review.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "Recruitment Report",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "Recruitment_Report_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "Upload_Recruitment_Report_Upload" },
            accept_multiple: false,
            required: true,
            validate: ["required", "file_required"],
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
          },
          // {
          //     machine_name: 'case_note',
          //     widget: 'text_area',
          //     label: 'Case Note',
          //     inputLimit: 400,
          //     rows: 7
          // }
        ],
      },
    ],
  };
}
